(function () {
    'use strict';

    angular.module('app.floorPlans', [
        'app.core',
        'app.widgets'
    ]);
})();
